import { bool, number, func } from 'prop-types';
import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';

import { C } from '../../common';
import { Consumer } from '../../context';
import { Motion, Touchable } from '../../reactor/components';
import styles from './Navigation.style';

const { AMPLITUDE: { CLICK_TYPE, ON_CLICK } } = C;

class Navigation extends PureComponent {
  static propTypes = {
    pageIndex: number.isRequired,
    onPress: func.isRequired,
    visible: bool,
  };

  static defaultProps = {
    visible: false,
  };

  _onPress = (index, logEvent) => {
    const { props: { onPress } } = this;
    logEvent(ON_CLICK, { type: CLICK_TYPE.ANCHOR, anchorPage: index });
    onPress(index);
  }

  render() {
    const { _onPress, props: { pageIndex, visible } } = this;

    return (
      <Consumer>
        { ({ dataSource: { pages = [] } = {}, logEvent }) => (
          <Motion
            style={styles.container}
            timeline={[{ property: 'opacity', value: visible ? 1 : 0 }]}
          >
            { pages.map(({ id, anchor }, index) => (
              <Motion
                key={id}
                style={StyleSheet.flatten([styles.item, anchor && styles.itemAnchor])}
                timeline={[{ property: 'opacity', value: index <= pageIndex ? 0.5 : 0.2 }]}
              >
                <Touchable onPress={() => _onPress(index, logEvent)} style={styles.touchable}>
                  <View />
                </Touchable>
              </Motion>))}
          </Motion>
        )}
      </Consumer>
    );
  }
}

export default Navigation;
